import React from 'react';
import {View} from 'react-native';
import {get, isNil, noop} from 'lodash';

import {REPORT_FRONTLINE_COACHES} from '/enum/records.enum';
import {isProdEnvironment} from '/util/env.util';

import {styles} from './MetricSection.style';
import {generateOnPress} from './MetricSectionItem.util';
import TouchableMetricItem from './TouchableMetricItem';

interface MetricListItem {
  label?: React.ReactNode;
  value?: number | string | null;
  component?: React.ElementType;
  recordsName?: string;
  readonly?: boolean;
}
interface MetricSectionItemProps {
  index: number;
  totalItemCount: number;
  listItem: MetricListItem;
  onItemPress: (item: MetricListItem) => void;
}

export const MetricSectionItem: React.FC<MetricSectionItemProps> = ({
  listItem = null,
  index = 0,
  totalItemCount = 0,
  onItemPress = noop,
}) => {
  const ListItemComponent = get(listItem, 'component');
  const recordsName = get(listItem, 'recordsName', '');
  const reportType = get(listItem, 'label.props.children');
  const value = get(listItem, 'value', null);
  const readonly = get(listItem, 'readonly', false);

  const ItemComponent = !isNil(ListItemComponent)
    ? ListItemComponent
    : TouchableMetricItem;

  /* istanbul ignore next */
  const isInDevelopment = !isProdEnvironment();

  if (!isInDevelopment && recordsName === REPORT_FRONTLINE_COACHES) {
    return null;
  }

  return (
    <View
      style={styles.listItemBorder}
      key={index}
      accessible={false}
      accessibilityRole="none">
      <ItemComponent
        index={index}
        totalItemCount={totalItemCount}
        item={listItem}
        onPress={generateOnPress({
          listItem,
          onItemPress,
          readonly,
          recordsName,
          reportType,
          value,
        })}
      />
    </View>
  );
};

export default MetricSectionItem;
